import React from "react";
import { Handle } from "@xyflow/react";

export const NodeWithImage = ({ id, data }) => {
  const connectionIndicatorStyle = {
    backgroundColor: "transparent",
    border: "none",
    boxShadow: "none",
  };

  return (
    <div
      className="flex flex-col items-center justify-center text-center h-24 rounded-lg p-2 relative"
      style={{ width: data.width }}
    >
      <img src={data.image} alt={data.label} className="w-9 h-9" />
      <div>{data.label}</div>
      {data.top && (
        <Handle
          type="target"
          position="top"
          style={{ ...connectionIndicatorStyle }}
          id={id}
        />
      )}
      {data.bottom && (
        <Handle
          type="source"
          position="bottom"
          style={{ ...connectionIndicatorStyle }}
          id={id}
        />
      )}
      {data.left && (
        <Handle
          type="source"
          position="right"
          style={{ ...connectionIndicatorStyle }}
          id={id}
        />
      )}
      {data.right && (
        <Handle
          type="target"
          position="left"
          style={{ ...connectionIndicatorStyle }}
          id={id}
        />
      )}
    </div>
  );
};
